import React, {Component} from 'react';
import Header from '../../components/Header';

class HeaderView extends Component {
    render() {
        return (
            <Header/>
        );
    }
}

export default HeaderView;


// WEBPACK FOOTER //
// ./src/views/Header/index.js